<template>
    <router-link
        to="/"
    >
      <img
          :src="this.$store.state.browserSize.width <= standard ?
          '/images/logo/logo-rebless-vertical.svg': '/images/logo/logo-rebless.svg'"
          alt="logo"
      >
    </router-link>
</template>
<script>
export default {
  name: 'Logo',
  data() {
    return {
      standard: 1600 // mediaQuery.scss 에서 정한 랩탑 기준점
    }
  }
}
</script>